
import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  public reloadSellComponent: EventEmitter<void> = new EventEmitter<void>();

  getOffsetValue(utcString: string) {
    const newMatch = utcString.match(/UTC[\W]\d{2}:\d{2}/gi);
    if(!newMatch) throw new Error('Invalid utcOffset')
    const result = newMatch[0].slice(3, newMatch[0].length);
    const number = Number(result.split(':').join('.'));
    if (isNaN(number)) return 0;
    return number;
  }
}
